module.exports = __webpack_public_path__ + "static/media/style-icon-active.c18407d7.svg";